import React, { FC } from 'react';
import { AuthCallback } from '~/components';

const MerchantAuthCallback: FC = () => <AuthCallback flowKey="marketplace-signup" />;

export default MerchantAuthCallback;
